<template>
  <!--  v-if="videoPlayBackList.length > 0"-->
  <div class="c-pc-recommend">
    <h4 class="recommend-tit"><b>更多回放</b></h4>
    <div v-if="!ReplayliveState" class="c-pc-recommend-box">
      <div v-for="(list, idx) in videoPlayBackList" :key="list.videoId">
        <div class="recommend-list">
          <div class="recommend-cover">
            <a
              @click="toNewPager(list, idx)"
              :class="{ 'a-no-hover': !list.url }"
            >
              <img v-bind:src="list.mapId" alt="" />
            </a>
          </div>
          <div class="recommend-main">
            <div class="recommend-name" :title="list.title">
              {{ list.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="ReplayliveState" class="c-pc-recommend-box">
      <div v-for="list in pcPackBackVideoList" :key="list.id">
        <div class="recommend-list">
          <div class="recommend-cover">
            <a>
              <img :src="list.img" alt="" />
            </a>
          </div>
          <div class="recommend-main">
            <div class="recommend-name">
              {{ list.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, cr } from "fire-wind-water";
import { socketModule } from "../../common/socket";
import getHlsSite from "../../common/getHlsSite";
import comonService from "../../services/comonService";

let player;
export default {
  name: "VideoLists",
  data() {
    return {
      webinarInfo: null,
      videoPlayBackList: [],
      defaultImage: require("../../assets/images/moren-tuijian.jpg"),
      currentVideoId: "", //当前播放的视频id
      isPlay: false, //视频是否是播放状态
      pcPackBackVideoList: [],
      ReplayliveState:
        window.location.href.indexOf("liveState=replay") > -1 &&
        window.location.href.indexOf("isSetting=1") > -1
          ? true
          : false //静态链接回放状态
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
      $subscriber.subscribe("webinarInfo-videoList", data => {
        this.videoPlayBackList = data;
        if (data.length > 0) {
          this.defaultPlayback(data[0], 0);
        }
      });
      $subscriber.subscribe("playerButtonStatus", data => {
        this.isPlay = data;
      });
      $subscriber.subscribe("simulateClickEvent", data => {
        this.toNewPager(data.href, data.idx);
      });
      $subscriber.subscribe("pcPackBackVideoList", data => {
        this.pcPackBackVideoList = data;
      });
    },
    toNewPager(href, idx) {
      //判断当前点击的视频 与正在播放的视频id是否相等  若相等不进行后续操作 跳出
      if (this.currentVideoId === href.videoId) {
        return;
      }
      if (this.isPlay) {
        console.log("斷開socket");
        //切换视频 如果正在播放中那么 断开socket
        socketModule.disconnect();
        $subscriber.emit("muduPlayerIsPlay", false);
        this.isPlay = false;
      }
      // $subscriber.emit("SwitchVideo", true);
      // 若当前id不相等 把id保存起来 或者通过player 传过去
      let currentVideoId = href.videoId;
      this.currentVideoId = currentVideoId;
      if (this.videoPlayBackList.length > 0) {
        let videoList = this.videoPlayBackList;
        let hlsSite;
        let webcastId = this.webinarInfo.webcastId; //频道id
        let isHavePpt = href.isBindPpt == "1" ? true : false; //一堆列表里面是否有ppt的  用来初始化不同的效果
        //获取 hlsSite
        hlsSite = getHlsSite.getHlsSite(videoList, currentVideoId);
        window.$sk.webinar.skSdkEvent({
          type: "switchVideo",
          data: {
            webcastId: webcastId,
            tenantId: this.webinarInfo.tenantId,
            videoBg: href.mapId,
            type: this.webinarInfo.replaySwitch == 1 ? "playback" : "live",
            hlsSite: this.webinarInfo.replaySwitch == 1 ? hlsSite : null,
            currentVideoId: currentVideoId,
            videoPlayBackList: this.videoPlayBackList,
            isHavePpt: isHavePpt,
            idx: idx,
            webCastProvider: this.webinarInfo.webCastProvider,
            needPpt: isHavePpt,
            nowVideo: href,
            isPlay: this.isPlay
          }
        });
        //增加播放次数
        this.service.postVideoIncTimes({
          tenantId: this.webinarInfo.tenantId,
          webinarId: this.webinarInfo.webinarId,
          videoId: href.videoId
        });
      }
    },
    defaultPlayback(href, idx) {
      this.currentVideoId = href.videoId;
      let videoList = this.videoPlayBackList;
      //获取 hlsSite
      let hlsSite = getHlsSite.getHlsSite(videoList, href.videoId);
      let isHavePpt = href.isBindPpt == "1" ? true : false;
      window.$sk.webinar.skSdkEvent({
        type: "init",
        data: {
          webcastId: this.webinarInfo.webcastId,
          tenantId: this.webinarInfo.tenantId,
          videoBg: href.mapId,
          type: this.webinarInfo.replaySwitch == 1 ? "playback" : "live",
          hlsSite: this.webinarInfo.replaySwitch == 1 ? hlsSite : null,
          currentVideoId: href.videoId,
          videoPlayBackList: this.videoPlayBackList,
          isHavePpt: isHavePpt,
          webCastProvider: this.webinarInfo.webCastProvider,
          needPpt: isHavePpt,
          nowVideo: href
        }
      });
      //增加播放次数
      this.service.postVideoIncTimes({
        tenantId: this.webinarInfo.tenantId,
        webinarId: this.webinarInfo.webinarId,
        videoId: href.videoId
      });
    },
    //获取真正的播放地址
    //如果videoOrigin中是m3u8第1优先用它，如果不是第2优先用转码信息中的url，它应该是m3u8，如果没有那还是用videoOrigin
    //以前的旧数据videoOrigin中就是m3u8。后来不知道什么时候变成了mp4/flv这样的格式。
    getRealMudoVodUrl(video) {
      var hlsSite =
        video.transcodeData &&
        video.transcodeData[0] &&
        video.transcodeData[0]["url"]
          ? video.transcodeData[0]["url"]
          : video.videoOrigin;
      if (video && video.videoOrigin) {
        var tempArray = video.videoOrigin.split(".");
        if (tempArray[tempArray.length - 1] === "m3u8") {
          hlsSite = video.videoOrigin;
        }
      }
      return hlsSite;
    }
  }
};
</script>

<style scoped></style>
